import { useTranslation } from "./i18n";
import RecordActionButton from "./RecordActionButton";

export default function RecordExportButton({
  onClick,
  onPrint,
  disabled = false,
}: {
  onClick?: () => void;
  onPrint?: () => void;
  disabled?: boolean;
}) {
  const { t } = useTranslation("classroomInterface");
  return (
    <div className="record-output-actions">
      {onPrint && <RecordActionButton action="print" disabled={disabled} aria-haspopup="dialog" onClick={onPrint} />}
      {onClick && (
        <RecordActionButton
          action="export"
          disabled={disabled}
          title={t("exportContextHint")}
          aria-haspopup="dialog"
          onClick={onClick}
        >
          {t("export")} <span aria-hidden="true">▾</span>
        </RecordActionButton>
      )}
    </div>
  );
}
